import Http from '../http';

export default {
  show(id) {
    return Http.get(`/done_personal_infos/${id}`)
  },
}